<template>
  <button @click="gotoRoute()" class="button-return" :class="colour">
    <div class="button-return-icon">
      <img
        v-if="colour === 'white'"
        src="/img/icon-return-white.svg"
        aria-hidden="true"
        focusable="false"
      />
      <img
        v-if="colour === 'black'"
        src="/img/icon-return.svg"
        aria-hidden="true"
        focusable="false"
      />
    </div>
    <span class="button-return-label">
      <slot>Back</slot>
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonReturn",
  props: {
    to: {
      type: [Object, String],
    },
    colour: {
      type: String,
      default: "white",
    },
  },
  data() {
    return {
      urlDev: "/",
      urlProd: "/",
    };
  },
  methods: {
    gotoRoute() {
      if (this.to) {
        this.$router.push(this.to);
      } else {
        const url =
          process.env.NODE_ENV === "development" ? this.urlDev : this.urlProd;

        window.open(url, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-return {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  background: transparent;
  border: none;
  font-size: rem(14px);
  color: $white;
  font-weight: $font-weight-bold;
  &:focus {
    outline: 4px solid #ffd086;
  }

  @media (max-width: 600px) {
    justify-content: flex-end;
    margin-bottom: rem(16px);
  }

  &.black {
    color: $black;
  }
}

.button-return-icon {
  display: inline-block;
  width: 20px;
  margin-right: 5px;

  img {
    display: block;
    width: 100%;
  }
}
</style>
